module.exports = __webpack_public_path__ + "img/bg-operation-walk.010d01a3.jpeg";